import type { JSX } from 'react';
import Box from 'carbon-react/esm/components/box';
import { Typography } from 'carbon-react/esm/components/typography/typography.component';

export interface AdminErrorItemsProps {
  error: string | null;
}

const AdminErrorItems = ({ error }: AdminErrorItemsProps): JSX.Element => {
  return (
    <Box p="23px">
      <Typography>Erreur: {error || 'Une erreur est survenue'}</Typography>
    </Box>
  );
};

export default AdminErrorItems;
